export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-Latin2-11a53319bf43aa331fe959debc3faeba.woff2";